"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignAdProductToJSON = exports.CampaignAdProductFromJSONTyped = exports.CampaignAdProductFromJSON = exports.CampaignAdProduct = void 0;
/**
 * The ad product of the campaign being created.
 * @export
 */
exports.CampaignAdProduct = {
    UNSET: 'UNSET',
    UNKNOWN: 'UNKNOWN',
    CONTENT: 'CONTENT',
    FIRST_IMPRESSION_STREAM: 'FIRST_IMPRESSION_STREAM',
    FITO: 'FITO',
    FORMATS_TEST: 'FORMATS_TEST',
    GUARANTEED: 'GUARANTEED',
    HOUSE: 'HOUSE',
    HPTO: 'HPTO',
    LAUNCHER: 'LAUNCHER',
    S4A: 'S4A',
    SBL: 'SBL',
    SPAN: 'SPAN',
    SAX_PROGRAMMATIC_GUARANTEED: 'SAX_PROGRAMMATIC_GUARANTEED'
};
function CampaignAdProductFromJSON(json) {
    return CampaignAdProductFromJSONTyped(json, false);
}
exports.CampaignAdProductFromJSON = CampaignAdProductFromJSON;
function CampaignAdProductFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CampaignAdProductFromJSONTyped = CampaignAdProductFromJSONTyped;
function CampaignAdProductToJSON(value) {
    return value;
}
exports.CampaignAdProductToJSON = CampaignAdProductToJSON;
